module.exports = __webpack_public_path__ + "img/rawpixel-578842-6237x3508.8b06851e.jpg";